import TextIcon from '@allesauto/core/TextIcon';
import { Locked32 } from '@carbon/icons-react';
import React, { FC } from 'react';

interface AccountFromWrapperProps {
  title: string;
  secureConnectionText?: string;
}

const AccountFormWrapper: FC<
  React.PropsWithChildren<AccountFromWrapperProps>
> = ({ title, children, secureConnectionText }) => (
  <div
    data-login="login"
    className="bg-white pb-30px pt-40px px-15px relative shadow w-full z-10 sm:mx-auto sm:rounded-lg md:p-60px md:pb-30px md:w-[480px]"
  >
    <h1 className="font-headline font-weight-bold mb-20px text-headline4">
      {title}
    </h1>
    {children}
    {secureConnectionText && (
      <TextIcon
        text={secureConnectionText}
        icon={<Locked32 className="mr-[8px] w-15px" />}
      />
    )}
  </div>
);

export default AccountFormWrapper;
